import { CATOGERY_LIST_GET_DONE } from "../../action/catogery";

const initState = {
    data: [],
    error: null,
    status: null,
    currentlogedInuser: null,
};

export const productCatogeryReducer = (state = initState, action) => {
    switch (action.type) {
        case CATOGERY_LIST_GET_DONE:
            return {
                ...state,
                data: {
                    data: action?.payload?.data?.data,
                    status: action?.payload?.data?.status,
                    error: null,
                },
            };
        default:
            return state;
    }
};
